import { render, staticRenderFns } from "./kyc_step_two.vue?vue&type=template&id=d607a504&scoped=true"
import script from "./kyc_step_two.vue?vue&type=script&lang=js"
export * from "./kyc_step_two.vue?vue&type=script&lang=js"
import style0 from "./kyc_step_two.vue?vue&type=style&index=0&id=d607a504&prod&scoped=true&lang=css"
import style1 from "./kyc_step_two.vue?vue&type=style&index=1&id=d607a504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d607a504",
  null
  
)

export default component.exports